export default __webpack_public_path__ + "static/characters01-5191830b6d87007f081e8617757ab214.png";